import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../axiosInstance';
import '../Main.css';
import { FaRegCalendarAlt } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";

const Blog = () => {
  const [state, setState] = useState({
    blogs: [],
    blogText: {},
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const [blogsResponse, blogTextResponse] = await Promise.all([
          axiosInstance.get('/blog/content'),
          axiosInstance.get('/blog/text')
        ]);

        // ✅ Sort blogs by date (latest first)
        const sortedBlogs = blogsResponse.data.sort((a, b) => {
          const [dayA, monthA, yearA] = a.date.split("-").map(Number);
          const [dayB, monthB, yearB] = b.date.split("-").map(Number);

          const dateA = new Date(yearA, monthA - 1, dayA);
          const dateB = new Date(yearB, monthB - 1, dayB);

          return dateB - dateA; // latest first
        });


        // Take only latest 3 blogs
        const latestBlogs = sortedBlogs.slice(0, 3);

        setState(prevState => ({
          ...prevState,
          blogs: latestBlogs,
          blogText: blogTextResponse.data[0]
        }));
      } catch (err) {
        setState(prevState => ({
          ...prevState,
          error: err.message
        }));
      } finally {
        setState(prevState => ({
          ...prevState,
          loading: false
        }));
      }
    };

    fetchBlogData();
  }, []);

  const { blogs, blogText, loading, error } = state;

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error fetching data: {error}</p>;
  }

  return (
    <div>
      <section className='blog-area'>
        <div className='container-blog'>
          <div className="blog-text">
            <span className='blog-title'>{blogText.title}</span>
            <h2>{blogText.heading}</h2>
            <p>{blogText.description}</p>
          </div>
          <div className="blog">
            {blogs.map(blog => (
              <div className="blog-card" key={blog._id}>
                <div className="single-blog-post">
                  <div className="post-image">
                    <img src={blog.image} alt="blog-img" style={{width: "400px", height: "300px"}}/>
                    <div className="date">
                      <FaRegCalendarAlt />
                      {blog.date}
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>{blog.BlogTitle}</h3>
                    <a href={blog.link} className='blog-read-more-btn'>
                      READ MORE<IoIosArrowForward />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* See All Blogs button */}
          <div className="see-all-btn">
            <Link to="/blogs" className="see-all-link">
              See All Blogs {'>'}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
